/** NavigationSettingsRoute — skin-aware switcher for /navigation-settings. */
import { useUISkin } from "@/data/UISkinContext";
import NavigationSettings from "./NavigationSettings";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function NavigationSettingsRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Admin · Navigation" title="Navigation Settings">
        <NavigationSettings />
      </CockpitFrame>
    );
  }
  return <NavigationSettings />;
}
